import { render, staticRenderFns } from "./warehousing-apply.vue?vue&type=template&id=38f38134"
import script from "./warehousing-apply.vue?vue&type=script&lang=ts"
export * from "./warehousing-apply.vue?vue&type=script&lang=ts"
import style0 from "./warehousing-apply.vue?vue&type=style&index=0&id=38f38134&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports